import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14","key":"svg-0"}],["path",{"d":"M10 16v-5h-4v-4h4v-4h4v4h4v4h-4v5","key":"svg-1"}]]

/**
 * IconGrave
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ3JhdmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgMjF2LTJhMyAzIDAgMCAxIDMgLTNoOGEzIDMgMCAwIDEgMyAzdjJoLTE0IiAvPgogIDxwYXRoIGQ9Ik0xMCAxNnYtNWgtNHYtNGg0di00aDR2NGg0djRoLTR2NSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/grave
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGrave = createReactComponent('outline', 'grave', 'Grave', __iconNode);

export default IconGrave;